import { handleActions } from 'redux-actions';
import merge from 'lodash/merge';
import { PRODUCTS_DELETE_ITEM_IMAGE } from './actions';
import { uploadActionTypes } from '../../redux/upload-descriptor';
import { createHttpInitState, createHttpReducers } from '../../redux/http-descriptor';

const initialState = merge(
  {},
  createHttpInitState('carDataImport'),
  createHttpInitState('carDataImportItem', 'put', [])
);

export default handleActions(
  {
    ...createHttpReducers('carDataImport'),
    ...createHttpReducers('carDataImportItem', 'put'),
    [PRODUCTS_DELETE_ITEM_IMAGE]: (state, { payload: { itemId, img } }) => ({
      ...state,
      cars: {
        ...state.cars,
        // list: state.cars.list.map(car => {
        //   if (car.id === itemId) {
        //     return removeImage(car, img);
        //   }

        //   return car;
        // }),
        data: state.cars.data && state.cars.data.id === itemId ? removeImage(state.cars.data, img) : state.cars.data,
      },
    }),
    [uploadActionTypes.UPLOAD_FILE_COMPLETE]: (state, { payload: { responseBody, context } }) => {
      return {
        ...state,
        cars: {
          ...state.cars,
          list: state.cars.list.map(car => {
            if (car.id === context.itemId) {
              return addImage(car, responseBody);
            }

            return car;
          }),
          data:
            state.cars.data && state.cars.data.id === context.itemId
              ? addImage(state.cars.data, responseBody)
              : state.cars.data,
        },
      };
    },
  },
  initialState
);

function removeImage(item, imgObject) {
  return {
    ...item,
    assets: {
      ...item.assets,
      imgs: item.assets.imgs.filter(img => img !== imgObject),
    },
  };
}

function addImage(item, imgObject) {
  return {
    ...item,
    assets: {
      ...item.assets,
      imgs: [...(item.assets.imgs || []), imgObject],
    },
  };
}
